import React, { useContext, useEffect, useState } from 'react';
//import io from 'socket.io-client';
//import mqtt from 'mqtt';
import { startOfWeek, addWeeks, getISOWeek, getISOWeeksInYear, getISOWeekYear } from 'date-fns'
import { Container, Form, Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import GraficaTemperatura from '../Graficas/GraficaTemperatura';
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
import GraficaTemperatura1 from '../Graficas/GraficaTemperatura1';
//import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function InterfazTemperatura() {

  const [estado, setEstado] = useState('Desconectado');
  const [tiempoRango, setTiempoRango] = useState('day');
  const [actualizar, setActualizar] = useState(false);
  const { loading, setLoading } = useContext(ContextGloball);
  const [regional, setRegional] = useState('');
  const [fecha, setFecha] = useState(() => {
    const hoy = new Date();
    return hoy.toISOString().split('T')[0]; 
  });

  const [datosTemperaturaDia, setDatosTemperaturaDia] = useState([]);

  const [temperaturasGrafica, setTemperaturasGrafica] = useState([]);
  const [tiemposGrafica, setTiemposGrafica] = useState([]);

  const [numeroMes, setNumeroMes] = useState(1);

  const [numeroSemana, setNumeroSemana] = useState(0);
  const [numeroAnio, setNumeroAnio] = useState(0);

  async function encontrarTemperaturasPorDia(diaSeleccionado, regionalAux = regional) {

    setLoading(true);

    setFecha(diaSeleccionado);

    

     
    try {
      var response = await fetch(`${server}/reporte/getTemperaturaPorRango`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          'regional': regionalAux,
          'fecha_inicial': diaSeleccionado,
          'fecha_final': null,
          'intervalo_minutos': 15
        })
      });
      if (response.ok) {
        let data = await response.json();

        console.log(data.ok);
        console.log(typeof(data.ok))

        if (typeof data.ok === 'string') {
          setDatosTemperaturaDia([]);
        }else{
          setDatosTemperaturaDia(data.ok);
        }
        setLoading(false);

      } else {
        setLoading(false);
        MsgUtils.msgError("No se pudo obtener las temperaturas");
      }
    } catch (networkError) {
      MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
      console.error("Error en fetch:", networkError);
      setLoading(false);
    }
    

  }

  function encontrarHoraMasCercanaAux(datos, horaObjetivo, umbralMinutos) {
    if (!datos.length) return null;

    const baseFecha = new Date(datos[0].FECHA);
    const [hora, minutos] = horaObjetivo.split(":").map(Number);
    const fechaObjetivo = new Date(baseFecha);
    fechaObjetivo.setHours(hora, minutos, 0, 0);

    let másCercano = null;
    let menorDiferencia = Number.MAX_SAFE_INTEGER;

    for (const actual of datos) {
      const fechaActual = new Date(actual.FECHA);
      const diferenciaMs = Math.abs(fechaActual - fechaObjetivo);
      const diferenciaMinutos = diferenciaMs / (1000 * 60); // convertir a minutos

      if (diferenciaMinutos <= umbralMinutos && diferenciaMinutos < menorDiferencia) {
        menorDiferencia = diferenciaMinutos;
        másCercano = actual;
      }
    }

    return másCercano;
  }

  async function encontrarTemperaturasPorSemana(semanaSeleccionada) {
    setLoading(true);

    let diasSemana = getDatesOfWeek(numeroAnio, semanaSeleccionada - 1)

    console.log(diasSemana)

    let fechaInicial = diasSemana[0];
    let fechaFinal = diasSemana[6];

    try {

      var response = await fetch(`${server}/reporte/getTemperaturaPorRango`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          'regional': regional,
          'fecha_inicial': fechaInicial,
          'fecha_final': fechaFinal,

        })
      });

      if (response.ok) {
        let data = await response.json();

        let datosTemperatura = new Array(7).fill(null);
        let dias = [`Lunes (${diasSemana[0]})`, `Martes (${diasSemana[1]})`, `Miercoles (${diasSemana[2]})`, `Jueves (${diasSemana[3]})`, `Viernes (${diasSemana[4]})`, `Sabado (${diasSemana[5]})` , `Domingo (${diasSemana[6]})`];

        for (let i = 0; i < datosTemperatura.length; i++) {

          if (data.ok[i].PROMEDIO) {
            datosTemperatura[i] = data.ok[i].PROMEDIO;
          }
        }

        console.log("Temperaturas enviar: ", datosTemperatura)
        setTemperaturasGrafica(datosTemperatura);
        setTiemposGrafica(dias);
        setLoading(false);

      } else {
        MsgUtils.msgError("No se pudo obtener las temperaturas");
        setLoading(false);
      }
    } catch (networkError) {
      MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
      console.error("Error en fetch:", networkError);
      setLoading(false);
    }
  }

  function getDatesOfWeek(year, weekNumber) {

    const firstDayOfYear = new Date(year, 0, 1);
    const firstDayOfWeek = firstDayOfYear.getDay(); 

    const daysToFirstMonday = firstDayOfWeek <= 1 ?
      1 - firstDayOfWeek :
      8 - firstDayOfWeek;

    const weekMonday = new Date(firstDayOfYear);
    weekMonday.setDate(firstDayOfYear.getDate() + daysToFirstMonday + (weekNumber - 1) * 7);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(weekMonday);
      currentDate.setDate(weekMonday.getDate() + i);

      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();

      dates.push(`${day}/${month}/${year}`);
    }

    return dates;
  }

  async function encontrarTemperaturasPorMes(mesSeleccionado) {

    setLoading(true);

    setNumeroMes(mesSeleccionado);

    let diasMes = getDatesOfMonth(numeroAnio, mesSeleccionado)

    console.log("Dias del mes: ", diasMes)

    let fechaInicial = diasMes[0];
    let fechaFinal = diasMes[diasMes.length - 1];

    console.log("Primer dia", fechaInicial)
    console.log("Ultimo dia", fechaFinal)

    try {
      var response = await fetch(`${server}/reporte/getTemperaturaPorRango`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          'regional': regional,
          'fecha_inicial': fechaInicial,
          'fecha_final': fechaFinal,

        })
      });
      if (response.ok) {
        let data = await response.json();
        let datosTemperatura = new Array(diasMes.length).fill(null);
        let dias = [];

        for (let j = 1; j < diasMes.length + 1; j++) {
          dias.push(j);
        }

        for (let i = 0; i < datosTemperatura.length; i++) {

          if (data.ok[i].PROMEDIO) {
            datosTemperatura[i] = data.ok[i].PROMEDIO;
          }
        }

        console.log("Temperaturas enviar: ", datosTemperatura)

        setTemperaturasGrafica(datosTemperatura);
        setTiemposGrafica(dias);

        setLoading(false);

      } else {
        MsgUtils.msgError("No se pudo obtener las temperaturas");
        setLoading(false);
      }
    } catch (networkError) {
      MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
      console.error("Error en fetch:", networkError);
      setLoading(false);
    }
  }

  function getDatesOfMonth(year, month) {
    const firstDayOfMonth = new Date(year, month - 1, 1);
    const lastDayOfMonth = new Date(year, month, 0);

    const dates = [];
    for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
      const currentDate = new Date(year, month - 1, day);

      const formattedDay = String(day).padStart(2, '0');
      const formattedMonth = String(month).padStart(2, '0');

      dates.push(`${formattedDay}/${formattedMonth}/${year}`);
    }

    return dates;
  }

  function getNumSemanaHoy() {
    var fechaHoy = new Date()
    var oneJan = new Date(fechaHoy.getFullYear(), 0, 1);
    var numberOfDays = Math.floor((fechaHoy - oneJan) / (24 * 60 * 60 * 1000));
    var result = Math.ceil((fechaHoy.getDay() + 1 + numberOfDays) / 7);
    return getISOWeek(fechaHoy)
  }

  function establecerTiempoRango(tiempoRango) {

    setTiempoRango(tiempoRango);

    const hoy = new Date();
    if (tiempoRango == 'day') {

      const fechaHoy = hoy.toISOString().split('T')[0];
      encontrarTemperaturasPorDia(fechaHoy);
      setFecha(fechaHoy);

    } else if (tiempoRango == 'week') {

      const semanaHoy = getNumSemanaHoy();
      encontrarTemperaturasPorSemana(numeroSemana);
      setNumeroSemana(semanaHoy);

    } else {

      const mesHoy = hoy.getMonth() + 1;
      console.log(mesHoy);
      setNumeroMes(mesHoy);
      encontrarTemperaturasPorMes(mesHoy);

    }
  }

  useEffect(async () => {
    

    let info = JSON.parse(localStorage.getItem('info'));
    setRegional(info.ID_REGIONAL_ACTUAL);

    if (numeroSemana === 0 && numeroAnio === 0) {
      var fechaHoy = new Date()
      var result = getNumSemanaHoy();

      setNumeroAnio(getISOWeekYear(fechaHoy));
      setNumeroSemana(result);

      encontrarTemperaturasPorDia(fechaHoy.toISOString().split('T')[0], info.ID_REGIONAL_ACTUAL);

    }

    /* 
    const client = mqtt.connect('ws://localhost:9001', {
      username: 'usuario_mqtt',
      password: 'kingdom',
    });

    client.on('connect', () => {
      console.log("Conectado");
      setEstado('Conectado');
      client.subscribe('/TempCamara');
    });

    client.on('message', (topic, message) => {
      if (topic === '/TempCamara') {
        try {
          console.log(`[MQTT] Mensaje recibido [${topic}]: ${message.toString()}`);
          const data = JSON.parse(message.toString());
          setTemperatura(data.temp);
        } catch (err) {
          console.error('Error al parsear JSON:', err);
        }
      }
    });

    client.on('error', (err) => {
      if (err.message !== 'client disconnecting') {
        console.error('Error MQTT:', err);
        setEstado('Error de conexión');
      }
    });

    return () => {
      client.end();
    };
  */

  }, []);

  return (
    <>
      {
        /*<h1>Monitor de Temperatura</h1>
        <h2>{estado} </h2>
  
        <p> temperatura: {temperatura}</p>*/
      }

      <Container>
        <Row>
          <Col className="text-center mt-3">
            <h2>
              Camara Pollo
            </h2>
          </Col>
        </Row>
      </Container>

      <Container className="mt-4" style={{ background: 'white', padding: '20px', borderRadius: '8px' }}>
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Rango de tiempo</Form.Label>
              <Form.Select
                value={tiempoRango}
                onChange={(e) => { establecerTiempoRango(e.target.value); }}
              >
                <option value="day">Día (Horas)</option>
                <option value="week">Semana (Días)</option>
                <option value="mes">Mes (Días)</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {tiempoRango == 'day' && <Col md={4}>
            <Form.Group>
              <Form.Label>Seleccionar dia</Form.Label>
              <Form.Control
                type="date"
                value={fecha}
                onChange={(e) => { encontrarTemperaturasPorDia(e.target.value); }}
              />
            </Form.Group>
          </Col>}

          {tiempoRango == 'week' && <Col md={2} className='pt-4'>

            <div className="d-flex justify-content-center">
              <ButtonGroup className=''>
                <Button variant='light' onClick={() => {
                  setNumeroSemana(numeroSemana - 1);
                  encontrarTemperaturasPorSemana(numeroSemana - 1);
                }}>
                  <i className="fa-solid fa-chevron-left"></i>
                </Button>
                <div className='bg-light fw-bold text-dark my-auto bg-gradient px-1' style={{ fontSize: '25px' }}>
                  {numeroSemana}
                </div>
                <Button variant='light' onClick={() => {
                  setNumeroSemana(numeroSemana + 1);
                  encontrarTemperaturasPorSemana(numeroSemana + 1);
                }}>
                  <i className="fa-solid fa-chevron-right"></i>
                </Button>
              </ButtonGroup>
            </div>

            <div className='text-dark text-center w-100' style={{ fontSize: '15px' }}>
              # Semana
            </div>

          </Col>}

          {tiempoRango == 'mes' && <Col md={4}>
            <Form.Group>
              <Form.Label>Seleccionar mes</Form.Label>
              <Form.Select
                value={numeroMes}
                onChange={(e) => { encontrarTemperaturasPorMes(e.target.value); }}
              >
                <option value="1">Enero</option>
                <option value="2">Febrero</option>
                <option value="3">Marzo</option>
                <option value="4">Abril</option>
                <option value="5">Mayo</option>
                <option value="6">Junio</option>
                <option value="7">Julio</option>
                <option value="8">Agosto</option>
                <option value="9">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>

              </Form.Select>
            </Form.Group>
          </Col>}
        </Row>
        <Row className="mt-4">
          <Col>
          {tiempoRango == 'day' && <GraficaTemperatura1 datosAux = {datosTemperaturaDia}/>}

          {(tiempoRango == 'week' || tiempoRango == 'mes' )  && <GraficaTemperatura timeRange={tiempoRango} temperaturas={temperaturasGrafica} tiempos={tiemposGrafica} />}
            
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default InterfazTemperatura;